enum ActionTypes {
  LOAD_PUBLIC_DESIGN = 'LOAD_PUBLIC_DESIGN',
  LOAD_CUSTOMER_DESIGN = 'LOAD_CUSTOMER_DESIGN',
  SET_DESIGN_DATA = 'SET_DESIGN_DATA',
  SET_DESIGN_STATUS = 'SET_DESIGN_STATUS',
}

export default ActionTypes;
